/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './searchRepos.defs.js'
export * as $defs from './searchRepos.defs.js'
